import { Injectable } from '@angular/core'
import { DateTime } from 'luxon'
import { Observable, throwError } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'

import { DrrHttpClient } from '../../http/drr-http-client'
import { AppointmentResponseSchema } from './appointment.model'
import { AppointmentRequest, AppointmentResponse } from './appointment.types'

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  constructor(private http: DrrHttpClient) {}

  getAppointmentTimes$(clubCode: string, request: AppointmentRequest): Observable<AppointmentResponse> {
    return this.http
      .post<AppointmentResponse>(`bff/club/${clubCode}/appointment-times`, {
        latitude: request.latitude,
        longitude: request.longitude,
        day: DateTime.fromJSDate(request.date).toISODate() // returns 'YYYY-MM-DD'
      })
      .pipe(
        tap((response) => AppointmentResponseSchema.validateSync(response)),
        catchError((error) => {
          // Handle 400 errors as "appointment not allowed for the given parameters"
          if (error?.response?.status === 400) {
            return throwError(new Error('Appointment not allowed for the given parameters'))
          }
          return throwError(error)
        })
      )
  }
}
